import { cx } from '@emotion/css'
import React from 'react'
import { AmpImg } from '../../content/Picture/Image.amp'
import { ResponsivePictureProps } from './Picture.web'
import { fixedRatioToBreakpointRatios, getCrops } from './utils'

export const AmpPicture: React.FC<ResponsivePictureProps> = ({
    image,
    fixedRatio,
    renderPicture = (pic) => pic,
    className,
}) => {
    if (!fixedRatio) {
        return null
    }

    const breakpointCrops = getCrops(
        image.crops,
        fixedRatioToBreakpointRatios(fixedRatio),
        false,
    )

    if (!breakpointCrops) {
        return null
    }

    const crop = breakpointCrops.default

    return renderPicture(
        <div className={cx(className, 'image')}>
            <AmpImage
                src={crop.reference}
                alt={image.altText}
                width={crop.width}
                height={crop.height}
            />
        </div>,
    )
}

export const AmpImage: React.FC<{
    src: string
    srcSet?: string
    alt?: string
    width: number
    height: number
    sizes?: string
    layout?: 'fill' | 'responsive' | undefined
}> = ({ src, srcSet, alt, width, height, sizes, layout = 'responsive' }) => {
    if (src.length === 0) {
        return null
    }

    return (
        <AmpImg
            src={src}
            srcSet={srcSet}
            alt={alt}
            width={width}
            height={height}
            sizes={sizes}
            layout={layout}
        >
            <noscript>
                <img src={src} alt={alt} />{' '}
                {/* src set not needed on amp noscript */}
            </noscript>
        </AmpImg>
    )
}
AmpPicture.displayName = 'AmpPicture'
